import { useAtomValue } from "jotai";
import { experimentsAtom } from "../../store";

export const useExperiment = (experiment: string) => {
  const allExperiments = useAtomValue(experimentsAtom);
  return allExperiments.get(experiment);
};
